import useScreenerAppContext from './use-screener-app-context';
import { PROFILE_API_TYPES } from '../../hooks/api';

const useScreenerCommonStore = () => {
  const {
    apiClient,
    channel,
    pageOffsetsTop,
    sideRail,
    page,
    UrlDomain,
    UrlPrefix
  } = useScreenerAppContext();

  const apiType = PROFILE_API_TYPES.prop;

  // the screener doesn't have a fund in context (no xid)
  const apiConfigBase = {
    apiType,
    channel,
    client: apiClient
  };

  return {
    apiConfigBase,
    commonState: {
      channel,
      hideForPWAChannelMobile: channel === 'pwa',
      pageOffsetsTop,
      sideRail,
      page,
      UrlDomain,
      UrlPrefix
    }
  };
};

export default useScreenerCommonStore;
